import { FC, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AppContext } from '../App';
import { FileControl } from '../components/FileControl';
import { UPLOAD_URL } from '../types/API_URLs';

export const FileUploader: FC = () => {
    const { accountNumberReq, setAccountNumberReq } = useContext(AppContext);
    //@ts-ignore:next-line
    const [fileState, setFileState] = useState(File[0]);
    //@ts-ignore:next-line
    const [fileStateTwo, setFileStateTwo] = useState(File[0]);
    //@ts-ignore:next-line
    const [fileStateThree, setFileStateThree] = useState(File[0]);
    //@ts-ignore:next-line
    const [fileStateFour, setFileStateFour] = useState(File[0]);
    //@ts-ignore:next-line
    const [fileStateFive, setFileStateFive] = useState(File[0]);
    //@ts-ignore:next-line
    const [niError, setNiError] = useState(['','','','','']);
    const [netPayError, setNetPayError] = useState(['','','','','']);
    const [wageSlipDateError, setWageSlipDateError] = useState(['','','','','']);
    const [showFileTwo, setShowFileTwo] = useState(false);
    const [showFileThree, setShowFileThree] = useState(false);
    const [showFileFour, setShowFileFour] = useState(false);
    const [showFileFive, setShowFileFive] = useState(false);
    const [showMoreFileOption, setshowMoreFileOption] = useState(true);
    const [maxFiles, setMaxFiles] = useState(5);
    const [uploadState, setUploadState] = useState('none');
    const navigate = useNavigate();

    useEffect(() => {
        !accountNumberReq.uuid && navigate('/');
    });

    const showUploadFile = (index: number) => {
        let uploadDetails = accountNumberReq.uploadDetails;
                uploadDetails.push({
                    ni:'',
                    wageSlipDate: '',
                    netPay: '',
                    file: null
                  });
                  setAccountNumberReq({ ...accountNumberReq, uploadDetails: uploadDetails });
        switch( index) {
            case 1:
                setShowFileTwo(true); 
                 
                break;
            case 2:
                setShowFileThree(true); 
                break;
            case 3:
                setShowFileFour(true); 
                break;
            case 4:
                setShowFileFive(true); 
                break;            
        }
        
    } 
    const showAddFiles = () => {
        var noOfFiles = 0;

        (!showFileTwo && fileState?.length > 0 && fileState?.length < 5) ? showUploadFile(1) : setshowMoreFileOption(false);

        fileState && (noOfFiles = fileState.length);
        fileStateTwo?.length > 0 && (noOfFiles += fileStateTwo.length);
        fileState && setMaxFiles(5 - noOfFiles);

        (!showFileThree && fileStateTwo?.length > 0 && noOfFiles < 5) ? showUploadFile(2) : setshowMoreFileOption(false);

        fileStateThree?.length > 0 && (noOfFiles += fileStateThree.length);
        fileStateTwo && setMaxFiles(5 - noOfFiles);

        (!showFileFour && fileStateThree?.length > 0 && noOfFiles < 5) ?
        showUploadFile(3) : setshowMoreFileOption(false);

        fileStateFour?.length > 0 && (noOfFiles += fileStateFour.length);
        fileStateThree && setMaxFiles(5 - noOfFiles);

        if (!showFileFive && fileStateFour?.length > 0 && noOfFiles < 5) {

            setMaxFiles(5 - noOfFiles);
            // setShowFileFive(true);
            showUploadFile(4);
            setshowMoreFileOption(false);
        }
    }


    const resetAllowedMaxFiles = () => {
        var noOfFiles = 0;

        fileState && (noOfFiles = fileState.length);
        fileStateTwo?.length > 0 && (noOfFiles += fileStateTwo.length);
        fileState && setMaxFiles(5 - noOfFiles);

        fileStateThree?.length > 0 && (noOfFiles += fileStateThree.length);
        fileStateTwo && setMaxFiles(5 - noOfFiles);

        fileStateFour?.length > 0 && (noOfFiles += fileStateFour.length);
        fileStateThree && setMaxFiles(5 - noOfFiles);

        fileStateFour && setMaxFiles(5 - noOfFiles);

        if (noOfFiles < 5 && !showFileFive) {
            setshowMoreFileOption(true);
        }

    }

    const uploadData = () => {
        setUploadState('loading');

        var data = new FormData()

        for (const file of fileState) {
            if(data.values?.length < 5) {
                data.append('uploadDetails[0].file', file, file.name);
            }
            data.append('uploadDetails[0].ni', accountNumberReq.uploadDetails[0].ni);
            data.append('uploadDetails[0].netPay', accountNumberReq.uploadDetails[0].netPay);
            data.append('uploadDetails[0].wageSlipDate', accountNumberReq.uploadDetails[0].wageSlipDate);
        }
        if (fileStateTwo?.length > 0) {
            for (const file of fileStateTwo) {
                data.values?.length < 5 && data.append('uploadDetails[1].file', file, file.name);
            }
            data.append('uploadDetails[1].ni', accountNumberReq.uploadDetails[1].ni);
            data.append('uploadDetails[1].netPay', accountNumberReq.uploadDetails[1].netPay);
            data.append('uploadDetails[1].wageSlipDate', accountNumberReq.uploadDetails[1].wageSlipDate);
        }
        if (fileStateThree?.length > 0) {
            for (const file of fileStateThree) {
                data.values?.length < 5 && data.append('uploadDetails[2].file', file, file.name);
            }
            data.append('uploadDetails[2].ni', accountNumberReq.uploadDetails[2].ni);
            data.append('uploadDetails[2].netPay', accountNumberReq.uploadDetails[2].netPay);
            data.append('uploadDetails[2].wageSlipDate', accountNumberReq.uploadDetails[2].wageSlipDate);
        }
        if (fileStateFour?.length > 0) {
            for (const file of fileStateFour) {
                data.values?.length < 5 && data.append('uploadDetails[3].file', file, file.name);
            }
            data.append('uploadDetails[3].ni', accountNumberReq.uploadDetails[3].ni);
            data.append('uploadDetails[3].netPay', accountNumberReq.uploadDetails[3].netPay);
            data.append('uploadDetails[3].wageSlipDate', accountNumberReq.uploadDetails[3].wageSlipDate);
        }
        if (fileStateFive?.length > 0) {
            for (const file of fileStateFive) {
                data.append('uploadDetails[4].file', file, file.name);
            }
            data.append('uploadDetails[4].ni', accountNumberReq.uploadDetails[4].ni);
            data.append('uploadDetails[4].netPay', accountNumberReq.uploadDetails[4].netPay);
            data.append('uploadDetails[4].wageSlipDate', accountNumberReq.uploadDetails[4].wageSlipDate);
        }

        data.append('postcode', accountNumberReq.postcode);
        data.append('accountNumber', accountNumberReq.accountNumber);
        data.append('uuid', accountNumberReq.uuid);
        data.append('lastName', accountNumberReq.lastName);
        data.append('dateOfBirth', accountNumberReq.dateOfBirth);
        data.append('uploadType', accountNumberReq.fileTye);
        data.append('creditorDocType', accountNumberReq.creditorDocType);
        data.append('incomeDocType', accountNumberReq.incomeDocType);
        data.append('IncomeExpenditureDocType', accountNumberReq.IncomeExpenditureDocType);
        data.append('OffsetEvidenceDocType', accountNumberReq.OffsetEvidenceDocType);
        data.append('PropertyDocType', accountNumberReq.PropertyDocType);
        data.append('VariationDocType', accountNumberReq.VariationDocType);
        data.append('carhpDocType', accountNumberReq.carhpDocType);
        data.append('OtherDocType', accountNumberReq.OtherDocType);
        data.append('token', accountNumberReq.token);

        fetch(UPLOAD_URL, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: data,
        }).then((resp) => {
            if (resp && resp.ok) {
                // reset relevant form state
                setAccountNumberReq({ ...accountNumberReq, fileTye: '', creditorDocType: '', incomeDocType: '', IncomeExpenditureDocType: '', OffsetEvidenceDocType: '', PropertyDocType: '', VariationDocType: '', carhpDocType: '', OtherDocType: '' })
                navigate('/complete');
            } else {
                setUploadState('error');
            }
        }
        ).catch(() => {
            setUploadState('error');
        }
        );
    }

    const filesStaged = fileState?.length > 0 || fileStateTwo?.length > 0 || fileStateThree?.length > 0 || fileStateFour?.length > 0 || fileStateFive?.length > 0;
    const updatedNi = (niValue: string, dataIndex: number) => {
        {
            let uploadDetails = accountNumberReq.uploadDetails;
            let updatedData = uploadDetails.map((uploadData,index) => {
            if(index === dataIndex) {
                uploadData.ni = niValue;
            }
            return uploadData;
        });
            setAccountNumberReq({ ...accountNumberReq, uploadDetails: updatedData });
        }
    }
    const updatedWageDate = (wageSlipDate: string, dataIndex: number) => {
        {
            let uploadDetails = accountNumberReq.uploadDetails;
            let updatedData = uploadDetails.map((uploadData,index) => {
            if(index === dataIndex) {
                uploadData.wageSlipDate = wageSlipDate;
            }
            return uploadData;
        });
            setAccountNumberReq({ ...accountNumberReq, uploadDetails: updatedData });
        }
    }
    const updatedNetPay = (netPay: string, dataIndex: number) => {
        {
            let uploadDetails = accountNumberReq.uploadDetails;
            let updatedData = uploadDetails.map((uploadData,index) => {
            if(index === dataIndex) {
                uploadData.netPay = netPay;
            }
            return uploadData;
        });
            setAccountNumberReq({ ...accountNumberReq, uploadDetails: updatedData });
        }
    }
    return (
        <div className="page">
            <div className="container">

                <h1 className="page__title u-m__b--l">Upload your files </h1>

                <div className="u-m__b--l">
                    <h2>We accept upto 5 files in PDF, JPG or PNG format upto 20mb.</h2>
                </div>
                <div>
                {accountNumberReq.incomeDocType === 'WAGE' && <div>Please provide payslip information and upload payslip.</div>}
                </div>
                <div id="files">
                    
                    <FileControl uploadState={uploadState} fileState={fileState} setFileState={setFileState} resetAllowedMaxFiles={resetAllowedMaxFiles} data-selector="file-1" setShowFileControl={() => { }} maxFiles={maxFiles} 
                    incomeDocType={accountNumberReq.incomeDocType} 
                    setNiValue={(value: string) => updatedNi(value, 0)}
                    setNetPayValue={(value: string) => updatedNetPay(value, 0)}
                    setWageSlipDate={(value: string) => updatedWageDate(value, 0)}
                    setNiError={(value: string) => {
                        const newNiError = [...niError];
                        newNiError[0] = value;
                        setNiError(newNiError);
                    }}
                    niError={niError[0]}
                    setNetPayError={(value: string) => {
                        const newNetPayError = [...netPayError];
                        newNetPayError[0] = value;
                        setNetPayError(newNetPayError);
                    }}
                    netPayError={netPayError[0]}
                    setWageSlipDateError={(value: string)=> {
                        const newWageSlipDateError = [...wageSlipDateError];
                        newWageSlipDateError[0] = value;
                        setWageSlipDateError(newWageSlipDateError);
                    }}
                    wageSlipDateError={wageSlipDateError[0]}
                    index={0}
                    />

                    {showFileTwo && <FileControl uploadState={uploadState} fileState={fileStateTwo} setFileState={setFileStateTwo} resetAllowedMaxFiles={resetAllowedMaxFiles} setShowFileControl={setShowFileTwo} data-selector="file-2" maxFiles={maxFiles} 
                    incomeDocType={accountNumberReq.incomeDocType} 
                    setNiValue={(value: string) => updatedNi(value, 1)}
                    setNetPayValue={(value: string) => updatedNetPay(value, 1)}
                    setWageSlipDate={(value: string) => updatedWageDate(value, 1)}
                    setNiError={(value: string) => {
                        const newNiError = [...niError];
                        newNiError[1] = value;
                        setNiError(newNiError);
                    }}
                    niError={niError[1]}
                    setNetPayError={(value: string) => {
                        const newNetPayError = [...netPayError];
                        newNetPayError[1] = value;
                        setNetPayError(newNetPayError);
                    }}
                    netPayError={netPayError[1]}
                    setWageSlipDateError={(value: string)=> {
                        const newWageSlipDateError = [...wageSlipDateError];
                        newWageSlipDateError[1] = value;
                        setWageSlipDateError(newWageSlipDateError);
                    }}
                    wageSlipDateError={wageSlipDateError[1]}
                    index={1}
                    />}
                    {showFileThree && <FileControl uploadState={uploadState} fileState={fileStateThree} setFileState={setFileStateThree} resetAllowedMaxFiles={resetAllowedMaxFiles} setShowFileControl={setShowFileThree} data-selector="file-3" maxFiles={maxFiles} 
                    incomeDocType={accountNumberReq.incomeDocType} 
                    setNiValue={(value: string) => updatedNi(value, 2)}
                    setNetPayValue={(value: string) => updatedNetPay(value, 2)}
                    setWageSlipDate={(value: string) => updatedWageDate(value, 2)}
                    setNiError={(value: string) => {
                        const newNiError = [...niError];
                        newNiError[2] = value;
                        setNiError(newNiError);
                    }}
                    niError={niError[2]}
                    setNetPayError={(value: string) => {
                        const newNetPayError = [...netPayError];
                        newNetPayError[2] = value;
                        setNetPayError(newNetPayError);
                    }}
                    netPayError={netPayError[2]}
                    setWageSlipDateError={(value: string)=> {
                        const newWageSlipDateError = [...wageSlipDateError];
                        newWageSlipDateError[2] = value;
                        setWageSlipDateError(newWageSlipDateError);
                    }}
                    wageSlipDateError={wageSlipDateError[2]}
                    index={2}
                    />}
                    {showFileFour && <FileControl uploadState={uploadState} fileState={fileStateFour} setFileState={setFileStateFour} resetAllowedMaxFiles={resetAllowedMaxFiles} setShowFileControl={setShowFileFour} data-selector="file-4" maxFiles={maxFiles} 
                    incomeDocType={accountNumberReq.incomeDocType} 
                    setNiValue={(value: string) => updatedNi(value, 3)}
                    setNetPayValue={(value: string) => updatedNetPay(value, 3)}
                    setWageSlipDate={(value: string) => updatedWageDate(value, 3)}
                    setNiError={(value: string) => {
                        const newNiError = [...niError];
                        newNiError[3] = value;
                        setNiError(newNiError);
                    }}
                    niError={niError[3]}
                    setNetPayError={(value: string) => {
                        const newNetPayError = [...netPayError];
                        newNetPayError[3] = value;
                        setNetPayError(newNetPayError);
                    }}
                    netPayError={netPayError[3]}
                    setWageSlipDateError={(value: string)=> {
                        const newWageSlipDateError = [...wageSlipDateError];
                        newWageSlipDateError[3] = value;
                        setWageSlipDateError(newWageSlipDateError);
                    }}
                    wageSlipDateError={wageSlipDateError[3]}
                    index={3}
                    />}
                    {showFileFive && <FileControl uploadState={uploadState} fileState={fileStateFive} setFileState={setFileStateFive} resetAllowedMaxFiles={resetAllowedMaxFiles} setShowFileControl={setShowFileFive} data-selector="file-5" maxFiles={maxFiles} 
                    incomeDocType={accountNumberReq.incomeDocType} 
                    setNiValue={(value: string) => updatedNi(value, 4)}
                    setNetPayValue={(value: string) => updatedNetPay(value, 4)}
                    setWageSlipDate={(value: string) => updatedWageDate(value, 4)}
                    setNiError={(value: string) => { 
                        const newNiError = [...niError];
                        newNiError[4] = value;
                        setNiError(newNiError);
                    }}
                    niError={niError[4]}
                    setNetPayError={(value: string) => {
                        const newNetPayError = [...netPayError];
                        newNetPayError[4] = value;
                        setNetPayError(newNetPayError);
                    }}
                    netPayError={netPayError[4]}
                    setWageSlipDateError={(value: string)=> {
                        const newWageSlipDateError = [...wageSlipDateError];
                        newWageSlipDateError[4] = value;
                        setWageSlipDateError(newWageSlipDateError);
                    }}
                    wageSlipDateError={wageSlipDateError[4]}
                    index={4}
                    />}

                </div>
                {uploadState === 'none' && filesStaged && showMoreFileOption && <button onClick={showAddFiles} className="btn u-m__t--l">Add more</button>}
                {uploadState === 'none' && filesStaged && <button onClick={uploadData} className="btn u-m__t--l">Submit</button>}

            </div>
        </div>
    );
}



